import React, {FunctionComponent, useEffect, useState} from 'react';
import {Box, makeStyles, Theme, Typography} from '@material-ui/core';
import {FormattedHTMLMessage, FormattedMessage, useIntl} from 'react-intl';
import RieltorBenefits from "../RieltorBenefits";

const useStyles = makeStyles<Theme>(theme => ({
    infoWrap:{
        borderRight: '1px solid #D9D9D9',
        paddingRight: 37,
        marginBottom: 31,
        paddingBottom: 8,
        [theme.breakpoints.down('xs')]: {
            paddingRight: 0,
            border: 0,
            borderBottom: '1px solid #D9D9D9',
            paddingBottom: 34
        }
    },
    infoTitle:{
        fontWeight: 700,
        marginBottom : 18,
        [theme.breakpoints.down('xs')]: {
            fontSize: 22
        }
    },
    infoText:{
        color: '#000',
        fontSize: 14,
        marginBottom: 30
    },

}));

interface LoginRegistrationInfoProps {
    title: String;
    subtitle: String;
}

const LoginRegistrationInfo: FunctionComponent<LoginRegistrationInfoProps> = ({title,subtitle }: LoginRegistrationInfoProps) => {
  const classes = useStyles();

    return (
    <>
    <Box className={classes.infoWrap}>
        <Typography variant="h5" className={classes.infoTitle}>
            {title}
        </Typography>
        <Box className={classes.infoText}>
            {subtitle}
        </Box>
        <RieltorBenefits/>
    </Box>

    </>
  );
};

export default LoginRegistrationInfo;